export enum SurveySummaryActionEnum {
  GET_SURVEY_SUMMARIES = 'GET_SURVEY_SUMMARIES'
}
